export const LocalStorageEnums = {
  TOKEN: 'accessToken',
  SID: 'accountSid',
  API_KEY: 'apiKey',
  API_TOKEN: 'apiToken',
  TWIML_APP_SID: 'twiMlAppSid'
};
